import {BasicManagedFile} from './basicManagedFile'
import {ELM} from '../Data/typeDirs'

class ElementTemplate extends BasicManagedFile {

  constructor(p){
    super(p)
    this.typeDir = ElementTemplate.getTypeDir()
    this.elm = null
    this.schemaId = null
    this.ext = 'elm'
  }

  static getIndices(){
    return `${BasicManagedFile.getIndices()},elm,schemaId`
  }

  construct(data){
    super.construct(data)
    this.schemaId = data.schemaId
    this.elm = data.elm
    return this
  }

  serialize(){
    let superSerialized = super.serialize()
    let {elm, schemaId} = this
    return {...superSerialized, schemaId, elm}
  }

  static getTypeDir(){
    return ELM
  }

}

export default ElementTemplate
